import { render, staticRenderFns } from "./category-ope.vue?vue&type=template&id=0aae07ec&scoped=true&"
import script from "./category-ope.vue?vue&type=script&lang=js&"
export * from "./category-ope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aae07ec",
  null
  
)

export default component.exports